// extracted by mini-css-extract-plugin
export default {"KeyboardRow":"Keyboard_KeyboardRow__UKBRL"};